export const CHANNEL_ID = {
  web: 1,
  tpv: 2,
  cash: 3,
  totem: 4,
  app: 5,
} as const;

export type ChannelKey = keyof typeof CHANNEL_ID;
